//
// ChildDefinitionsMenu for RecordInspector
//
// Informational list of child definitions, grouped by base with nested extensions.
//

import { observer } from 'mobx-react-lite'
import { forwardRef, Fragment } from 'react'
import { useStore } from '../../../stores'

import { Icon, Menu, MenuHeader, MenuItem, TreeItem } from '../../../components'
import { groupExtensionsByBaseFromRecords } from '../../../stores/data/extension-groups'

const CountTag = ({ title, children }) => (
    <span className="role" title={title}>
        {children}
    </span>
)

const ExtensionRow = forwardRef(function ExtensionRow(
    { name, count, hasLink, style },
    ref
) {
    const { app } = useStore()
    return (
        <TreeItem ref={ref} style={style}>
            {name}

            <CountTag count={count}>
                {hasLink ? (
                    <Icon
                        name="link"
                        size="text"
                        style={{ marginLeft: 4 }}
                        title={app.text('From linked record')}
                    />
                ) : null}
                {count}
            </CountTag>
        </TreeItem>
    )
})

const BaseRow = forwardRef(function BaseRow({ name, count, linkCount, style }, ref) {
    const { app } = useStore()
    return (
        <TreeItem ref={ref} style={style}>
            {name}
            {count ? <CountTag>{count}</CountTag> : null}
            {linkCount ? (
                <CountTag count={linkCount} title={app.text('From linked record')}>
                    <Icon
                        name="link"
                        size="text"
                        style={{ position: 'relative', top: 1 }}
                    />
                    {linkCount}
                </CountTag>
            ) : null}
        </TreeItem>
    )
})

export const ChildDefinitionsMenu = observer(function ChildDefinitionsMenu({
    worksheet,
}) {
    const { app, data } = useStore()
    const families = groupExtensionsByBaseFromRecords(
        worksheet.children,
        data.definitions
    )

    return (
        <Menu>
            <MenuHeader>{app.text('Child definitions')}</MenuHeader>
            {families.length ? (
                families.map(family => (
                    <Fragment key={family.key}>
                        <BaseRow
                            name={family.base.name}
                            count={family.base.count}
                            linkCount={family.base.linkCount}
                            style={{ paddingLeft: 5 }}
                        />
                        {family.extensions.map(extension => (
                            <ExtensionRow
                                key={extension.key}
                                name={extension.name}
                                count={extension.count}
                                hasLink={extension.hasLink}
                                style={{ paddingLeft: 15 }}
                            />
                        ))}
                    </Fragment>
                ))
            ) : (
                <MenuItem disabled>{app.text('No children')}</MenuItem>
            )}
        </Menu>
    )
})
